import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { supabase } from '../lib/supabase';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../context/ThemeContext';
import ArchiveNavDropdown from './ArchiveNavDropdown';
import './Header.css';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, isAdmin } = useAuth();
  const { t, i18n } = useTranslation();
  const { theme, toggleTheme } = useTheme();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    window.location.href = '/';
  };

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);
  const closeMenu = () => setIsMenuOpen(false);

  const LANGS = ['ko', 'en', 'ja'];
  const LANG_LABELS = { ko: 'KO', en: 'EN', ja: 'JA' };
  const toggleLang = () => {
    const idx = LANGS.indexOf(i18n.language);
    const next = LANGS[(idx + 1) % LANGS.length];
    i18n.changeLanguage(next);
    localStorage.setItem('koiro-lang', next);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="left-logo">
          <div className="logo-meta">
            <span className="logo-vol">Vol. 01</span>
            <span className="logo-sep">·</span>
            <span className="logo-vol">2026</span>
          </div>
          <Link to="/" onClick={closeMenu}>KOIRO</Link>
          <span className="logo-rule" />
        </div>

        <button className="menu-toggle" onClick={toggleMenu}>☰</button>

        <div className={`right-group ${isMenuOpen ? 'open' : ''}`}>
          <nav className="nav">
            <ul className="nav-list">
              <li>
                <NavLink to="/" end data-text={t('nav.home')}
                  className={({ isActive }) => isActive ? 'active' : ''}
                  onClick={closeMenu}>{t('nav.home')}</NavLink>
              </li>
              <li>
                <NavLink to="/about/koiro" data-text={t('nav.koiro')}
                  className={({ isActive }) => isActive ? 'active' : ''}
                  onClick={closeMenu}>{t('nav.koiro')}</NavLink>
              </li>
              <li>
                <NavLink to="/journey" data-text={t('nav.journey')}
                  className={({ isActive }) => isActive ? 'active' : ''}
                  onClick={closeMenu}>{t('nav.journey')}</NavLink>
              </li>
              <ArchiveNavDropdown onNavigate={closeMenu} />
              <li>
                <NavLink to="/projects" end data-text={t('nav.projects')}
                  className={({ isActive }) => isActive ? 'active' : ''}
                  onClick={closeMenu}>{t('nav.projects')}</NavLink>
              </li>
              <li>
                <NavLink to="/memories" data-text={t('nav.memories')}
                  className={({ isActive }) => isActive ? 'active' : ''}
                  onClick={closeMenu}>{t('nav.memories')}</NavLink>
              </li>
            </ul>
          </nav>

          <div className="auth-button-container">
            <button className="theme-toggle" onClick={toggleTheme} aria-label={t('ui.darkMode')} title={theme === 'dark' ? t('ui.lightMode') : t('ui.darkMode')}>
              {theme === 'dark' ? (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="5"/>
                  <line x1="12" y1="1" x2="12" y2="3"/>
                  <line x1="12" y1="21" x2="12" y2="23"/>
                  <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
                  <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                  <line x1="1" y1="12" x2="3" y2="12"/>
                  <line x1="21" y1="12" x2="23" y2="12"/>
                  <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
                  <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
                </svg>
              ) : (
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                </svg>
              )}
            </button>
            <button className="lang-toggle" onClick={toggleLang} aria-label={t('ui.lang')}>
              {LANG_LABELS[i18n.language] || 'KO'}
            </button>
            {user ? (
              <button className="auth-btn" onClick={handleLogout}>Logout</button>
            ) : (
              <Link to="/login" className="auth-btn" onClick={closeMenu}>Login</Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
